var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-default-line"},[_c('button',{staticClass:"btn btn-secondary btn-block btn-dropdown",attrs:{"type":"button"}},[_c('span',{staticClass:"status-item",class:[
        _vm.resolveStatusClass(_vm.statusKey.toLowerCase()),
      ]},[_vm._v(_vm._s(_vm.status.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }